import { PaginationProps, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { tableGreenStrStyle } from 'features/report/components/Component';
import { IResConsentFormItem } from 'features/report/services/types/consentForm';
import styled from 'styled-components';
import { formatPhone } from 'utils/formatPhone';

type Props = {
  data: IResConsentFormItem[];
  pagination: PaginationProps;
  handleChangePage: (page: number) => void;
};

const ConsentFormTable = ({ data, pagination, handleChangePage }: Props) => {
  const columns: ColumnsType<IResConsentFormItem> = [
    {
      title: 'Tickets',
      dataIndex: 'ticketNumber',
      key: 'ticketNumber',
      width: 100,
      render: (value) => <TicketNumberBox>#{value}</TicketNumberBox>,
    },
    {
      title: 'Date & Time',
      dataIndex: 'createdDate',
      key: 'createdDate',
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      key: 'customerName',
    },
    {
      title: 'Customer Phone',
      dataIndex: 'customerPhone',
      key: 'customerPhone',
      render: (value) => formatPhone(value),
    },
    {
      title: 'Services',
      dataIndex: 'services',
      key: 'services',
      render: (value) => <div className='services-text'>{value.join(', ')}</div>,
    },
    {
      title: 'Signature',
      dataIndex: 'signature',
      key: 'signature',
      render: (link) => (
        <a className='link-table' href={link} target='_blank' rel='noopener noreferrer'>
          signature.png
        </a>
      ),
    },
    {
      title: 'File',
      dataIndex: 'file',
      key: 'file',
      render: (link) => (
        <a className='link-table' href={link} target='_blank' rel='noopener noreferrer'>
          file.png
        </a>
      ),
    },
  ];

  return (
    <TableStyled>
      <Table
        rowKey={'id'}
        columns={columns}
        dataSource={data}
        style={{ width: '100%', padding: '1rem' }}
        rowClassName={'row-table'}
        pagination={{
          ...pagination,
          onChange: handleChangePage,
        }}
        scroll={{ y: 1000 }}
      />
    </TableStyled>
  );
};

export default ConsentFormTable;

const TicketNumberBox = styled.div`
  width: fit-content;
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #fff;

  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 4px;
  background: #232f3e;
`;

const TableStyled = styled.div`
  ${tableGreenStrStyle}
  flex: 1;
  box-shadow: none;
  border: none;
  .ant-table-wrapper {
    padding: 0;
  }
  .ant-table-wrapper .ant-table {
    .ant-table-thead th.ant-table-cell {
      height: 48px;
      padding: 0px 8px;
      gap: 10px;
      align-self: stretch;
      border-bottom: 1px solid #ccd4dc;
      background: #6fabb6;
      color: #fff;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: capitalize;
      text-align: left !important;
      &::before {
        width: 1.5px !important;
        height: 100% !important;
      }
    }

    .ant-table-tbody td.ant-table-cell {
      color: #1d2129;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    .ant-table-tbody .ant-table-row:nth-child(even) td {
      background: #e4f4f6;
      border-bottom: 1px solid #e4f4f6;
    }
  }

  .link-table {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1 0 0;
    overflow: hidden;
    color: #4384ff;
    text-overflow: ellipsis;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .services-text {
    //   display: -webkit-box;
    //   -webkit-box-orient: vertical;
    //   -webkit-line-clamp: 1;
    //   flex: 1 0 0;
    //   overflow: hidden;
    //   text-overflow: ellipsis;
  }
`;
